import { CurrentBusinessUnitCurrencyCodeSelector } from 'invision-core/src/components/session/businessunit.selectors';
import clone from 'ramda/src/clone';
import find from 'ramda/src/find';
import pathOr from 'ramda/src/pathOr';
import propEq from 'ramda/src/propEq';
import { stateGo } from 'redux-ui-router';
import { CurrentCustomerCurrencyCodeSelector, CurrentCustomerIdSelector, CurrentCustomerIsExternallyManagedARSelector, IsPIIDataAccessEnabledSelector, RoutePreviousState } from '../../../reducers/selectors/customer.selectors';
import { activatePaymentInstrument, anonymizePaymentInstrument, clearEWalletError, clearSelectedItemId, clearSelectedPaymentMethod, editPaymentInstrument, removePaymentInstrument, retrieveAvailablePaymentInstrumentTypes, retrieveWallet, selectPaymentMethod, setIncludeRemovedFilter, setPaymentInstrumentDefault, setSelectedItemId } from '../../../reducers/actions/customer.ewallet.actions';
import { setPaymentInstrumentFilter } from '../../../reducers/actions/customer.transactions.actions';
import { searchSubscriptions } from '../../../reducers/actions/customer.subscriptions.actions';
import { PageNumberSelector, RecordCountSelector, SubscriptionsPaymentInstruments, TotalPagesSelector, SubscriptionErrorSelector } from '../../../reducers/selectors/customer.subscriptions.selectors';
import { CurrentDefaultPaymentModel, DefaultPaymentMethodAutoPaySelector, DefaultPaymentMethodSelector, EwalletErrorSelector, EwalletRetrievalErrorSelector, IncludeRemovedSelector, IsRetrievingEwalletDataSelector, PaymentInstrumentsWithTypeNamesViewModel, SelectedPaymentAutoPayEnable, SelectedPaymentIsDirectSource, SelectedPaymentModelBasedOnRecoverableUI, SelectedItemIdSelector, SelectedTypeIdSelector } from '../../../reducers/selectors/customer.ewallet.selectors';
import { isReadOnlyException } from '../../../reducers/helpers/ewallet.reducer.helper';
import * as ComponentViewModelSelectors from '../ewallet/detail/ewallet.detail.component.selector';
import { MetadataActions, MetadataConstants, MetadataSelectors, PermissionService, SessionSelectors } from 'invision-core';
import { E_WALLET_ADMIN_ACCESS, ANONYMIZE_SUBSCRIBER_IMMEDIATELY_ACCESS, SUBSCRIBER_ANONYMIZATION_ACCESS } from '../../../security.attributes';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { BLANK_PAYMENT_INSTRUMENT } from '../makePayment/make.payment.constants';
import { retrieveCustomerHouseholds } from '../../../reducers/actions/customer.household.actions';
import { CurrentHouseholdSelector, CurrentMemberHasCreatePaymentInstrumentPermissionsSelector } from '../../../reducers/selectors/customer.household.selectors';
import { GIFT_CARD_DETAILS } from '../../giftCard/gift.card.config';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { RouteParams } from 'invision-core/src/components/router/router.selectors';
import CustomerCareLocaleKeys from '../../../locales/keys';
function CustomerEwalletController($ngRedux, $timeout, $anchorScroll, uiNotificationService) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      convergentBillerAccounts: DefaultPaymentMethodAutoPaySelector(store),
      currentBusinessUnitCurrencyCode: CurrentBusinessUnitCurrencyCodeSelector(store),
      currentCustomerCurrencyCode: CurrentCustomerCurrencyCodeSelector(store),
      currentCustomerId: CurrentCustomerIdSelector(store),
      currentCustomerIsExternallyManagedAR: CurrentCustomerIsExternallyManagedARSelector(store),
      currentHousehold: CurrentHouseholdSelector(store),
      currentSubHasEditPermission: CurrentMemberHasCreatePaymentInstrumentPermissionsSelector(store),
      creditCardTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.CreditCardType, store),
      defaultPaymentMethod: DefaultPaymentMethodSelector(store),
      defaultPaymentMethodModel: CurrentDefaultPaymentModel(store),
      externalBillTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.ExternalBillType, store),
      externalGiftCardTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.ExternalGiftCardType, store),
      braintreeMethodTypesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.BraintreeMethodType, store),
      brandableCurrenciesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.BrandableCurrency, store),
      includeRemoved: IncludeRemovedSelector(store),
      isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store),
      isFetchingEwalletData: IsRetrievingEwalletDataSelector(store),
      lastAttemptError: EwalletErrorSelector(store),
      paymentInstruments: PaymentInstrumentsWithTypeNamesViewModel(store),
      routePreviousState: RoutePreviousState(store),
      retrieveEwalletError: EwalletRetrievalErrorSelector(store),
      selectedPaymentMethod: SelectedPaymentModelBasedOnRecoverableUI(store),
      selectedPaymentMethodAutoPayEnable: SelectedPaymentAutoPayEnable(store),
      selectedPaymentMethodIsDirectSource: SelectedPaymentIsDirectSource(store),
      selectedItemId: SelectedItemIdSelector(store),
      selectedTypeId: SelectedTypeIdSelector(store),
      subscriberListError: SubscriptionErrorSelector(store),
      subscriberListNumberOfPages: TotalPagesSelector(store),
      subscriberListPageNumber: PageNumberSelector(store),
      subscriberListPaymentInstruments: SubscriptionsPaymentInstruments(store),
      subscriberListRecordCount: RecordCountSelector(store),
      templatePaymentDetail: ComponentViewModelSelectors.TemplatePaymentDetailSelector(store),
      timeZonesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.TimeZone, store),
      userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store),
      routeParams: RouteParams(store)
    };
  };
  var controllerActions = {
    activatePaymentInstrument: activatePaymentInstrument,
    anonymizePaymentInstrument: anonymizePaymentInstrument,
    clearEWalletError: clearEWalletError,
    clearSelectedItemId: clearSelectedItemId,
    clearSelectedPaymentMethod: clearSelectedPaymentMethod,
    editPaymentInstrument: editPaymentInstrument,
    fetchCodeType: MetadataActions.codes.fetchCodeTypes,
    removePaymentInstrument: removePaymentInstrument,
    retrieveCustomerHouseholds: retrieveCustomerHouseholds,
    retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
    retrieveWallet: retrieveWallet,
    selectPaymentMethod: selectPaymentMethod,
    searchSubscriptions: searchSubscriptions,
    setIncludeRemovedFilter: setIncludeRemovedFilter,
    setPaymentInstrumentFilter: setPaymentInstrumentFilter,
    setPaymentInstrumentDefault: setPaymentInstrumentDefault,
    setSelectedItemId: setSelectedItemId,
    stateGo: stateGo
  };
  var FIRST_SUBSCRIPTION_PAGE = 1;
  var findPaymentMethodById = function findPaymentMethodById(id) {
    return find(propEq(id, 'Id'));
  };
  this.$onInit = function () {
    _this.$timeout = $timeout;
    _this.$anchorScroll = $anchorScroll;
    _this.localeKeys = CustomerCareLocaleKeys;
    _this.showPaymentInstrumentForm = false;
    _this.subscriptionPageNumber = FIRST_SUBSCRIPTION_PAGE;
    _this.newEditPaymentMethodPopupConfig = {
      onRegisterApi: function onRegisterApi(event) {
        _this.newEditPaymentMethodPopupApi = event.api;
      }
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.loadHouseholdData();
    _this.retrieveWalletAndUpdateSelectedItem();
    _this.actions.retrieveAvailablePaymentInstrumentTypes({
      Currency: _this.state.currentCustomerCurrencyCode || _this.state.currentBusinessUnitCurrencyCode
    }).catch(function (error) {
      uiNotificationService.transientError(error.translatedMessage);
    });
    fetchSubscriptions(_this.subscriptionPageNumber);
    if (!_this.state.creditCardTypeLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.CreditCardType);
    }
    if (!_this.state.externalBillTypeLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.ExternalBillType);
    }
    if (!_this.state.externalGiftCardTypeLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.ExternalGiftCardType);
    }
    _this.stateOrName = 'index.customercare.customer.ewallet';
    _this.optionalParams = {
      customerId: _this.state.currentCustomerId
    };
    _this.shouldShowBackBanner = _this.state.routePreviousState.name === GIFT_CARD_DETAILS;
    if (!_this.state.timeZonesLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.TimeZone);
    }
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
  var fetchSubscriptions = function fetchSubscriptions(pageNumber) {
    var data = {
      IncludePaymentInstrumentInfo: true,
      IncludeRemoved: false,
      PageNumber: pageNumber,
      PageSize: 100,
      SortDirection: 2
    };
    return _this.actions.searchSubscriptions(_this.state.currentCustomerId, data).catch(function () {
      if (_this.state.subscriberListError) {
        _this.uiNotificationService.error(_this.state.subscriberListError.message, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      }
    });
  };
  this.eWalletEditable = function () {
    return _this.state.isPIIDataAccessEnabled;
  };
  this.currentDefaultPaymentInstrumentHasSubscriptions = function () {
    return _this.state.subscriberListPaymentInstruments.find(function (name) {
      return name === _this.state.defaultPaymentMethod.Name;
    });
  };
  this.currentDefaultPaymentIsReadOnly = function () {
    var currentDefaultPaymentMethodType = pathOr('', ['Type'], _this.state.defaultPaymentMethodModel);
    var readOnlyException = isReadOnlyException(currentDefaultPaymentMethodType);
    if (readOnlyException) {
      return false;
    } else {
      return !_this.state.defaultPaymentMethodModel || !_this.state.defaultPaymentMethodModel.actionables.canOrder;
    }
  };
  this.openAddPaymentMethodPopup = function () {
    _this.modalPaymentMethod = clone(BLANK_PAYMENT_INSTRUMENT);
    _this.showPaymentInstrumentForm = true;
    _this.$timeout(function () {
      _this.newEditPaymentMethodPopupApi.open();
    });
  };
  this.openEditPaymentMethodPopup = function (paymentMethodToEdit) {
    _this.modalPaymentMethod = clone(paymentMethodToEdit);
    _this.showPaymentInstrumentForm = true;
    _this.isEditingPaymentInstrument = true;
    _this.$timeout(function () {
      _this.newEditPaymentMethodPopupApi.open();
    });
  };
  this.handleSelectedPaymentMethod = function (paymentInstrument) {
    _this.setSelectedPaymentMethod(paymentInstrument);
    _this.scrollToSelectedItem();
  };
  this.setSelectedPaymentMethod = function (paymentInstrument) {
    var itemId = null;
    if (_this.state.selectedItemId !== paymentInstrument.Id) {
      itemId = paymentInstrument.Id;
    } else if (_this.state.selectedItemId) {
      itemId = _this.state.selectedItemId;
    }
    _this.actions.setSelectedItemId(itemId);
    var paymentMethod = findPaymentMethodById(itemId)(_this.state.paymentInstruments);
    _this.actions.selectPaymentMethod(paymentMethod);
  };
  this.scrollToSelectedItem = function () {
    if (!_this.isInView("ewalletItem-".concat(_this.state.selectedItemId), 'customer-ewallet-list')) {
      _this.$anchorScroll("ewalletItem-".concat(_this.state.selectedItemId));
    }
  };
  this.isInView = function (element, parentElement) {
    var elementObj = angular.element("#".concat(element))[0];
    if (elementObj) {
      var elementRect = elementObj.getBoundingClientRect();
      var parentElementRect = angular.element(parentElement)[0].getBoundingClientRect();
      var elementTopBorder = elementRect.top + elementRect.height;
      var elementBottomBorder = elementRect.bottom - elementRect.height;
      return !(elementTopBorder > parentElementRect.bottom || elementBottomBorder < parentElementRect.top);
    } else {
      return true;
    }
  };
  this.includeRemovedAndSelectPaymentType = function () {
    _this.actions.setIncludeRemovedFilter(true);
    _this.retrieveWallet().then(function () {
      var paymentInstrument = _this.state.paymentInstruments.find(propEq(_this.state.selectedTypeId, 'Type'));
      _this.setSelectedPaymentMethod(paymentInstrument);
    });
  };
  this.includeRemovedAndSelectPaymentInstrument = function () {
    _this.actions.setIncludeRemovedFilter(true);
    _this.retrieveWallet().then(function () {
      var paymentInstrument = _this.state.paymentInstruments.find(propEq(_this.state.selectedItemId, 'Id'));
      _this.setSelectedPaymentMethod(paymentInstrument);
    });
  };
  this.handleIncludeRemovedClick = function () {
    _this.actions.setIncludeRemovedFilter(!_this.state.includeRemoved);
    _this.retrieveWallet().then(function () {
      if (!_this.selectedPaymentPersists()) {
        _this.handleSelectFirstPaymentMethod();
      }
    });
  };
  this.loadHouseholdData = function () {
    if (!_this.state.currentHousehold) {
      _this.actions.retrieveCustomerHouseholds(_this.state.currentCustomerId, false);
    }
  };
  this.retrieveWallet = function () {
    return _this.actions.retrieveWallet({
      customerId: _this.state.currentCustomerId,
      request: {
        IncludeRemoved: _this.state.includeRemoved
      }
    }).catch(function (payload) {
      uiNotificationService.error(payload.translatedMessage, null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    });
  };
  this.currentCustomerHasPaymentMethods = function () {
    return _this.state.paymentInstruments && _this.state.paymentInstruments.length > 0;
  };
  this.currentCustomerHasSelectedPaymentMethod = function () {
    return _this.state.selectedPaymentMethod && _this.state.selectedPaymentMethod.Id;
  };
  this.closeNewEditPaymentMethodPopup = function () {
    _this.newEditPaymentMethodPopupApi.close();
    _this.actions.clearEWalletError();
    _this.isEditingPaymentInstrument = false;
    _this.showPaymentInstrumentForm = false;
  };
  this.onCreateOrEditPaymentMethodComplete = function (paymentInstrument) {
    _this.closeNewEditPaymentMethodPopup();
    _this.setSelectedPaymentMethod(paymentInstrument);
  };
  this.paymentMethodType = function () {
    var paymentMethod = findPaymentMethodById(_this.state.selectedItemId)(_this.state.paymentInstruments);
    return String(paymentMethod.Type);
  };
  this.paymentMethodRemove = function (currentCustomerId, paymentMethodId) {
    return _this.actions.removePaymentInstrument(currentCustomerId, paymentMethodId);
  };
  this.paymentMethodAnonymize = function (currentCustomerId, paymentMethodId) {
    return _this.actions.anonymizePaymentInstrument(currentCustomerId, paymentMethodId);
  };
  this.setPaymentInstrumentFilter = function (selectedPaymentMethod) {
    return _this.actions.setPaymentInstrumentFilter(selectedPaymentMethod);
  };
  this.activatePaymentInstrument = function (currentCustomerId, paymentMethod) {
    return _this.actions.activatePaymentInstrument(currentCustomerId, paymentMethod);
  };
  this.setPaymentInstrumentDefault = function (currentCustomerId, paymentMethod, applyToSubscriptions) {
    return _this.actions.setPaymentInstrumentDefault(currentCustomerId, paymentMethod, applyToSubscriptions).then(function () {
      if (!paymentMethod.ConvergentBillerPaymentInstrumentAccounts.length && _this.state.convergentBillerAccounts.ConvergentBillerPaymentInstrumentAccounts && _this.state.convergentBillerAccounts.ConvergentBillerPaymentInstrumentAccounts.length) {
        paymentMethod.ConvergentBillerPaymentInstrumentAccounts = clone(_this.state.convergentBillerAccounts.ConvergentBillerPaymentInstrumentAccounts);
        paymentMethod.Default = true;
        var request = {
          updateAutoPay: true,
          customerId: currentCustomerId,
          request: {
            PaymentInstrument: paymentMethod
          }
        };
        _this.actions.editPaymentInstrument(request);
      }
      fetchSubscriptions(_this.subscriptionPageNumber);
    });
  };
  this.stateGo = function (location, state) {
    return _this.actions.stateGo(location, state);
  };
  this.fetchCodeType = function (code) {
    return _this.actions.fetchCodeType(code);
  };
  this.handlePaymentMethodRemoved = function () {
    _this.retrieveWallet().then(function () {
      if (!_this.state.includeRemoved) {
        _this.handleSelectFirstPaymentMethod();
      }
    });
  };
  this.handlePaymentMethodAnonymized = function () {
    _this.retrieveWallet().then(function () {
      if (!_this.state.includeRemoved) {
        _this.handleSelectFirstPaymentMethod();
      }
    });
  };
  this.handleSelectFirstPaymentMethod = function () {
    if (_this.state.paymentInstruments.length > 0) {
      _this.setSelectedPaymentMethod(_this.state.paymentInstruments[0]);
    } else {
      _this.actions.clearSelectedPaymentMethod();
    }
  };
  this.selectedPaymentPersists = function () {
    return !!find(propEq(_this.state.selectedItemId, 'Id'))(_this.state.paymentInstruments);
  };
  this.retrieveWalletAndUpdateSelectedItem = function () {
    _this.retrieveWallet().then(function () {
      if (_this.state.selectedItemId) {
        var paymentInstrument = _this.state.paymentInstruments.find(propEq(_this.state.selectedItemId, 'Id'));
        if (paymentInstrument) {
          _this.setSelectedPaymentMethod(paymentInstrument);
        } else {
          _this.includeRemovedAndSelectPaymentInstrument();
        }
      } else {
        if (_this.state.selectedTypeId) {
          var _paymentInstrument = _this.state.paymentInstruments.find(propEq(_this.state.selectedTypeId, 'Type'));
          if (_paymentInstrument) {
            _this.setSelectedPaymentMethod(_paymentInstrument);
          } else {
            _this.includeRemovedAndSelectPaymentType();
          }
        } else {
          _this.handleSelectFirstPaymentMethod();
        }
      }
    });
  };
  this.handlePaymentMethodUpdated = function () {
    _this.retrieveWalletAndUpdateSelectedItem();
  };
  this.userHasAdminPermissions = function () {
    return PermissionService.hasAdminAccess(_this.state.userSecurityAttributes, E_WALLET_ADMIN_ACCESS);
  };
  this.canAdd = function () {
    return _this.userHasAdminPermissions() && _this.state.currentSubHasEditPermission && _this.state.timeZonesLoaded && _this.state.isPIIDataAccessEnabled;
  };
  this.onBannerClose = function () {
    _this.shouldShowBackBanner = false;
  };
  this.canAnonymizePaymentMethod = function () {
    return _this.userHasAdminPermissions() && PermissionService.hasAccess(_this.state.userSecurityAttributes, ANONYMIZE_SUBSCRIBER_IMMEDIATELY_ACCESS) && PermissionService.hasAccess(_this.state.userSecurityAttributes, SUBSCRIBER_ANONYMIZATION_ACCESS);
  };
}
export default {
  bindings: {},
  template: require('./ewallet.html'),
  controller: CustomerEwalletController,
  controllerAs: 'ewalletController'
};